import axios from 'axios'
import { loadingService } from '@/utils/loadingService'
import { toastService } from '@/utils/toastService'
import i18n from '@/i18n'
import store from '@/store'
import { localeToRegionIdMap, uniteTenementId, errorCodeMap } from '@/config/const'

const makeErrorMessage = (errorCode) => {
  const errorMessage = errorCodeMap[errorCode]
  if (!errorMessage) {
    return i18n.global.t('api.serverError') + errorCode
  }
  return i18n.global.t(errorMessage)
}


const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
})

instance.interceptors.request.use(config => {
  // if (config.url !== '/json/web/queryWebOrderById') {
  //   loadingService.show()
  // }
  const locale = store.state.locale
  const { method, data = {}, params = {} } = config
  const baseParams = {
    req: {
      regionId: localeToRegionIdMap[locale],
      uniteTenementId
    }
  }
  if (method === 'post') {
    const mergeParams = {
      req: {
        ...baseParams.req,
        ...data
      }
    }
    config.data = mergeParams
  } else if (method === 'get') {
    const mergeParams = {
      req: {
        ...baseParams.req,
        ...params
      }
    }
    config.params = mergeParams
  }
  return config
}, error => {
  return Promise.reject(error)
})


const http = async ({ method = 'post', url, data = {}, params = {}, options = {} } = {}) => {
  const { showLoading = true, showToast = true } = options
  try {
    if (showLoading) {
      loadingService.show()
    }
    const res = await instance({ method, url, data, params })
    if (showLoading) {
      loadingService.hide()
    }
    // debugger
    if (res.data.tars_ret === 0) {
      return res.data.data
    } else {
      if (showToast) {
        toastService.show(makeErrorMessage(res.data.tars_ret))
      }
      return Promise.reject(res)
    }
  } catch (error) {
    console.error(error)
    if (showToast) {
      toastService.show(error.message)
    }
    if (showLoading) {
      loadingService.hide()
    }
    return Promise.reject(error)
  }
}

export default http
